import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { COMMA, ENTER, X } from '@angular/cdk/keycodes';
import { map, Observable, startWith } from 'rxjs';
import { PagesService } from 'src/app/core/_services/pages/pages.service';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastrService } from 'ngx-toastr';
import { UploadService } from 'src/app/core/_services/common/upload.service';
import { AppConst, APP_CONSTANT } from 'src/app/core/_constants/app.constant';
import { RouteConstant } from 'src/app/core/_constants/route.constant';
import { Router } from '@angular/router';
import { ValidationService } from 'src/app/core/_services/common/validation.service';
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import * as moment from 'moment';
import { ChoosePaymentComponent } from '../choose-payment/choose-payment.component';
import { ConfirmDialogComponent } from '../confirm-dialog.component';
import { OnlinePaymentComponent } from '../online-payment/online-payment.component';
import { PaymentCompletedComponent } from '../payment-completed/payment-completed.component';
import { ComingSoonDialogComponent } from '../../coming-soon-dialog/coming-soon-dialog.component';
import { LocalStorageProvider } from 'src/app/core/_services/common/storage.service';

export function nonZeroValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isValid = control.value > 0;
    return isValid ? null : { nonZero: true };
  };
}

@Component({
  selector: 'app-add-client-dialogs',
  templateUrl: './add-client-dialogs.component.html',
  styleUrls: ['./add-client-dialogs.component.scss']
})
export class AddClientDialogsComponent implements OnInit, AfterViewInit {
  phoneCategoryArray: any = ['Mobile', 'Home', 'Work', 'Home Fax', 'Work Fax'];
  success: any
  validationErrorMessage = APP_CONSTANT.VALIDATION;
  maxLength = AppConst.MAXLENGTH;
  imageUrl: any = '';
  services: Array<string> = [];
  filteredServices!: Observable<string[]>;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  allServices: Array<string> = [];
  public addClientForm: FormGroup;
  submitted: boolean = false;
  @ViewChild('serviceInput') serviceInput: any;
  imageInvalidMsg: string = '';
  imageInvalid: boolean = false;
  coordinates: { lat: any; long: any; } = { lat: '', long: '' };
  serviceList: any = [];
  phoneNumber: any;
  allSelected = false;
  maxTrucks: number = AppConst?.MAX_TRUCKS;
  paymentModeArray: any = [
    { type: 'Online', value: 1 },
    { type: 'Offline', value: 2 }
  ]
  paymentDurationArray: any = [
    { type: '1 Month', value: 1 },
    { type: '3 Months', value: 3 },
    { type: '1 Year', value: 12 }
  ]
  paymentPlansArray = [
    { type: 'Starter', value: 'Starter' },
    { type: 'Business', value: 'Business' },
    { type: 'Premium', value: 'Premium' },
  ]

  AddOnsArray = [
    { type: 'AI Routing', value: 'aiRouting' },
    { type: 'Email Marketing', value: 'emailMarketing' },
    { type: 'Notifications', value: 'notifications' },
    { type: 'AI Phone Agent', value: 'aiPhoneAgent' }
  ]
  @ViewChild('select') select: MatSelect;
  contactList: any = [];
  todayDate = moment();
  constructor(public dialogRef: MatDialogRef<AddClientDialogsComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog, private storage: LocalStorageProvider,
    private service: PagesService, private fb: FormBuilder, private loader: NgxUiLoaderService, private el: ElementRef, private toastr: ToastrService, private upload: UploadService, private router: Router, public validationService: ValidationService) {
    this.addClientForm = this.createForm();
    if (this.data.type === 1) {
      this.addMoreNumber();
      this.addMoreContact();
    }
  }
  ngAfterViewInit(): void {
    // throw new Error('Method not implemented.');
    setTimeout(() => {
      this.addClientForm.patchValue({
        startDate: moment().format('yyyy-MM-DD')
      });
      this.getPackagesList();
    })

    if (this.storage.getItem('clientForm') && !this.data.data) {
      this.addClientForm.patchValue(this.storage.getItem('clientForm'));
      this.imageUrl = this.addClientForm.value.companyLogo;
    }
  }

  currentUserData: any;
  ngOnInit(): void {
    this.currentUserData = this.storage.getItem('opAvail');
    this.getServiceList();
    if (this.data.type == 2) {
      this.addClientForm.patchValue({
        companyLogo: this.data.data?.logo ? this.data.data?.logo : this.data.data?.profilePic,
        companyName: this.data.data.name,
        serviceId: this.data.data?.serviceIds,
        address: this.data.data?.address?.addressLine1,
        street: this.data.data?.address?.addressLine2,
        city: this.data.data?.address?.city,
        state: this.data.data?.address?.state,
        country: this.data.data?.address?.country,
        zipCode: this.data.data?.address?.zipCode,
        website: this.data?.data?.website,
        package: this.data?.data?.subscription_data?.interval ? this.data?.data?.subscription_data?.interval['length'] : '',
        amount: this.data?.data?.subscription_data?.amount || '',
        startDate: this.data?.data?.subscription_data?.startDate ? moment(this.data?.data?.subscription_data?.startDate) : '',
        paymentMode: this.data?.data?.subscription_data?.paymentMode || '',
      })
      this.addClientForm.removeControl("amount");
      this.addClientForm.removeControl("package");
      this.addClientForm.removeControl("startDate");
      this.addClientForm.removeControl("paymentMode");
      this.addClientForm.removeControl('numberOfTrucks')
      this.data.data.phone.forEach((x: any) => {
        this.addMoreNumber(x.number.substr(2, x.number.length), x.category)
      })
      if (this.data.data.contact) {
        this.data.data.contact.forEach((x: any) => {
          this.addMoreContact(x.contactTitle, x.fullName, x.email, x.phone[0]?.number.substr(2, x.phone[0]?.number.length), x.phone[0]?.category, x._id);
        })
      } else {
        this.addMoreContact();
      }
      this.coordinates = { lat: this.data.data.address?.lat, long: this.data.data.address?.long };
      this.imageUrl = this.data.data.logo ? this.data.data?.logo : "assets/images/person.svg";
    }
    else {
      this.imageUrl = 'assets/images/person.svg';
    }
    if (this.data.data) {
      this.data.data.address = this.data.data.address.filter(items => !items.isDeleted)
      this.patchAddresses(this.data)

    }
    else {
      this.addServiceAddress();

    }
  }

  packageList: any[] = [];
  getPackagesList() {
    const payload = {
      page: 1,
      limit: 1000
    }
    this.loader.start();
    this.service.get(payload, `${API_ROUTES.PACKAGES.packagesList}`).subscribe((res: any) => {
      this.loader.stop();
      if (res.status) {
        this.packageList = res.data.list.map(item => {
          return {
            _id: item._id,
            packageName: item.packageName,
            amount: item.amount,
            pricing: item?.pricing || []
          }
        });
        if (this.storage.getItem('clientForm') && !this.data.data) {
          this.setAmount({ value: this.addClientForm.value.package });
          this.selectedPackage = this.packageList.find(item => item._id === this.addClientForm.get('package').value);
          this.calculateAddonPrice(this.addClientForm.get('addOns').value);
        }
      } else {
        this.toastr.error(res);
      }
    }, (err: any) => {
      this.loader.stop();
      this.toastr.error(err.msg);
    })
  }

  isAmountZero: boolean = false;
  selectedPackage: any;
  setAmount(event) {
    this.selectedPackage = this.packageList.find(item => item._id === event.value);
    const addOnsControl = this.addClientForm.get('addOns');
    if (this.selectedPackage.amount == 0) {
      this.payment.writeValue(2);
      this.isAmountZero = true;
      this.addClientForm.patchValue({
        paymentMode: 2
      })
    } else {
      this.isAmountZero = false;
    }
    let total = this.selectedPackage.pricing.packagePrice;
    const trucks = this.addClientForm.get('numberOfTrucks')?.value || 0;
    if (trucks > 0) total += trucks * this.selectedPackage.pricing.truckPrice
    this.addClientForm.patchValue({
      amount: Number(total).toFixed(2)
    })
    addOnsControl?.enable();
    this.addClientForm.get('amount').disable();
  }

  setTodecimal(): any {
    if (this.addClientForm.value.amount) {
      this.addClientForm.patchValue({ amount: Number(this.addClientForm.value.amount).toFixed(2) })
    }
  }

  createForm() {
    return this.fb.group({
      companyLogo: [''],
      companyName: ['', Validators.required],
      serviceId: [''],
      serviceAddress: this.fb.array([]),
      phone: this.fb.array([]),
      website: ['', [Validators.pattern(AppConst.WEBSITE_PATTERN)]],
      contact: this.fb.array([]),
      package: ['', Validators.required],
      amount: ['', [Validators.required, nonZeroValidator()]],
      numberOfTrucks: ['', [Validators.required, Validators.min(1),
      Validators.max(this.maxTrucks)]],
      startDate: ['', Validators.required],
      paymentMode: ['', Validators.required],
      addOns: [{ value: [], disabled: true }]
    })
  }

  setAddOns(event: any) {
    const selectedValues = event.value; // array of selected values
    console.log("Selected AddOns =", selectedValues);

    // If you want to do calculations, update prices, etc.
    this.calculateAddonPrice(selectedValues);
  }

  calculateAddonPrice(selectedAddons: string[] = []) {

    if (!this.selectedPackage) return;

    const pricing = this.selectedPackage.pricing;

    // Base price of the package
    let total = pricing.packagePrice;

    // Add AddOns
    selectedAddons.forEach(addon => {
      const priceKey = addon + "Price";  // example: aiRouting → aiRoutingPrice
      if (pricing[priceKey] !== undefined) {
        total += pricing[priceKey];
      }
    });

    // Also add trucks price if you want:
    const trucks = this.addClientForm.get('numberOfTrucks')?.value || 0;
    if (trucks > 0) total += trucks * pricing.truckPrice;

    // Finally update the formControl
    this.addClientForm.get('amount')?.setValue(Number(total).toFixed(2));
  }


  limitInput(event: any) {
    const value = event.target.value;

    // Allow empty
    if (!value) {
      this.calculateAddonPrice(this.addClientForm.get('addOns').value);
      return;
    }

    // If typed number is outside 1–30, clear last typed char
    if (Number(value) < 1 || Number(value) > this.maxTrucks) {
      event.target.value = value.slice(0, -1);
    }
    this.addClientForm.get('numberOfTrucks')?.setValue(event.target.value);

    // *** Recalculate amount whenever trucks change ***
    this.calculateAddonPrice(this.addClientForm.get('addOns').value);
  }

  getServiceList() {
    this.service.get({}, `${API_ROUTES.CLIENT.getServiceList}`).pipe().subscribe((response: any) => {
      if (response.status) {
        this.serviceList = response.data.list;
        if (this.data.type == 2 && this.data.data?.services && this.data.data?.services.length == this.serviceList.length) {
          this.allSelected = true;
        }
      }
    })
  }

  submitForm(post: any) {
    console.log(this.addClientForm.value)

    const isAllPrimaryFalse = this.addClientForm.value.serviceAddress.every(address => !address.isPrimary);
    if (isAllPrimaryFalse) {
      this.toastr.error('Please select a primary address')
      return
    }
    this.submitted = true;
    if (this.addClientForm.valid) {
      if (this.data?.type == 1) {
        this.storage.setItem('clientForm', this.addClientForm.getRawValue());
      }
      post.phone.forEach((item: any) => {
        if (!item.number.includes('+1')) {
          item.number = '+1' + item.number;
        }
      });
      post.contact.forEach((item: any) => {
        if (!item.contactNumber.includes('+1')) {
          item.contactNumber = '+1' + item.contactNumber;
        };
      })

      const packageName = this.packageList.find(item => item._id === post.package)
      const addOnsToSend = {
        aiRouting: post?.addOns?.includes("aiRouting") ?? false,
        emailMarketing: post?.addOns?.includes("emailMarketing") ?? false,
        notifications: post?.addOns?.includes("notifications") ?? false,
        aiPhoneAgent: post?.addOns?.includes("aiPhoneAgent") ?? false
      }
      const data = {
        companyName: post.companyName,
        companyLogo: post.companyLogo,
        serviceId: post.serviceId === '' ? [] : post.serviceId,
        address: this.addClientForm.value.serviceAddress,
        phone: post.phone,
        contact: post.contact,
        website: post.website,
        paymentMode: post.paymentMode,
        amount: post?.amount,
        packageId: post.package,
        startDate: moment(post.startDate).format('yyyy-MM-DD'),
        deletedAddress: this.deletedArray,
        packageName: packageName?.packageName,
        permissionId: packageName?.permissionId,
        numberOfTrucks: post?.numberOfTrucks,
        addOns: addOnsToSend
      }
      console.log(data)

      const add = data.address.map((addr) => {
        return {
          ...addr,
          addressLine1: Array.isArray(addr.addressLine1) ? addr.addressLine1.join(" ") : addr.addressLine1,
          addressLine2: Array.isArray(addr.addressLine2) ? addr.addressLine2.join(" ") : addr.addressLine2
        };
      });
      data.address = add;
      data['duration'] = 1;
      this.data.type == 1 ? this.addClient(data) : this.updateClient({ ...data, ...{ companyId: this.data.data._id } });
    } else {
      this.addClientForm.markAllAsTouched();
      this.scrollToFirstInvalidControl();
    }
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      "form .ng-invalid"
    );

    if (firstInvalidControl) {
      firstInvalidControl.focus(); //without smooth behavior
    }
  }


  @ViewChild('payment') payment: MatSelect;
  isOnline(event: any) {
    if (event.value == 1 && !this.currentUserData) {
      const dialogRef = this.dialog.open(ComingSoonDialogComponent, {
        maxHeight: '100vh',
        width: '500px',
        disableClose: true,
        data: {

        }
        // data: {
        //   heading: "Add New Client",
        // }
      });
      dialogRef.afterClosed().subscribe((confirm: any) => {
        this.payment.writeValue(2);
        this.addClientForm.patchValue({
          paymentMode: 2
        })
        console.log(this.addClientForm.value);

      });
    }
    if (this.isAmountZero) {
      this.payment.writeValue(2);
      this.addClientForm.patchValue({
        paymentMode: 2
      })
    }
  }

  addClient(data: any) {
    delete data['deletedAddress']
    if (data.paymentMode == 1) {

      this.openOnlinePaymentOption(data)
    }
    else {
      this.openOfflinePaymentOption(data)
    }
  }

  openOfflinePaymentOption(data: any) {
    const dialogRef = this.dialog.open(ChoosePaymentComponent, {
      maxHeight: '450px',
      width: '700px',
      maxWidth: '100%',
      panelClass: 'choose-modalbox',
      disableClose: true,
      data: {
        heading: 'Choose mode of payment',
        isOnline: false,
        clientData: data
      }
    })
    dialogRef.afterClosed().subscribe((confirm: any) => {
      if (confirm !== undefined && confirm !== null && confirm) {
        data = { ...data, ...confirm }
        this.submitAddClient(data)
      }
    });
  }

  openOnlinePaymentOption(data: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxHeight: '100vh',
      width: '500px',
      disableClose: true,
      data: {
        title: `${APP_CONSTANT.CLIENT.ONLINE.title}`,
        sayYes: `${APP_CONSTANT.CLIENT.ONLINE.sayYes}`,
        sayNo: `${APP_CONSTANT.CLIENT.ONLINE.sayNo}`,
        img: ``
      }
    });
    dialogRef.afterClosed().subscribe((confirm: any) => {
      if (confirm !== undefined && confirm !== null && confirm) {
        this.openOnlinePaymentPopup(data)
      }
      else {
        this.submitAddClient(data)
      }
    });
  }

  openOnlinePaymentPopup(data) {
    const dialogRef = this.dialog.open(OnlinePaymentComponent, {
      maxHeight: '100vh',
      width: '700px',
      maxWidth: '100%',
      disableClose: true,
      data: {
        clientData: data
      }
    });
    dialogRef.afterClosed().subscribe((confirm: any) => {
      if (confirm !== undefined && confirm !== null && confirm) {
        data = { ...data, ...confirm }
        this.submitAddClient(data)
      }
    });
  }

  submitAddClient(data: any) {
    if (data.payeeDetails && data.paymentMethod === 3) {
      const [year, month] = data.payeeDetails.expirationDate.split('-');
      const formattedDate = `${month}${year.slice(2)}`;
      data.payeeDetails.expirationDate = formattedDate;
      data.isPayLater = false
    } else {
      data.isPayLater = true;
    }
    if (data.paymentMode === 2) {
      delete data.isPayLater
    }
    this.loader.start();
    this.service.post2(data, `${API_ROUTES.CLIENT.addNewClient}`).subscribe((response: any) => {
      if (response.status) {
        this.toastr.success(response.msg);
        this.resetForm();
        this.close(true);
        if (data.payeeDetails) {
          const dialogRef = this.dialog.open(PaymentCompletedComponent, {
            maxHeight: '100vh',
            width: '700px',
            maxWidth: '100%',
            disableClose: true,
          })
        }
      } else {
        if (response.data.isSubError) {
          this.toastr.success('Invitation Sent Successfully');
          setTimeout(() => {
            this.toastr.error(response);
          }, 500);
        } else {
          this.toastr.error(response.msg)
        }
        this.close(true);
      }
      this.loader.stop()
    }, (err) => {
      this.toastr.error(err.msg);
      this.loader.stop()
    })
  }

  get f() { return this.addClientForm.controls; }

  updateClient(data: any) {
    this.loader.start();
    this.service.post(data, `${API_ROUTES.CLIENT.updateClient}`).pipe().subscribe((response: any) => {
      if (response.status) {
        this.toastr.success(response.msg);
        this.close(true);
        this.router.navigate([`${RouteConstant.Client}`])
      } else {
        this.toastr.error(response);
      }
      this.loader.stop()
    })
  }

  async fileupload(e: any) {
    const selectedFile = e.target.files[0];
    if (e.target.files && e.target.files.length) {
      this.loader.start();
      let uploadedImage: any = await this.upload.uploadFile(selectedFile);
      if (uploadedImage) {
        this.imageUrl = uploadedImage;
        this.addClientForm.controls['companyLogo'].setValue(uploadedImage);
        this.loader.stop();
        this.imageInvalidMsg = "";
        this.imageInvalid = false;
        return true;
      } else {
        this.loader.stop();
        this.toastr.error(`${AppConst.ERROR_MESSAGES.SERVER_ERROR}`)
        return false;
      }
    }
    return false;

  }

  clearSearch(event: any) {
    this.addClientForm.patchValue({
      address: '',
      street: '',
      city: '',
      state: '',
      country: '',
      zipCode: '',
    })
  }



  remove(service: any) {
    const index = this.services.indexOf(service);
    if (index >= 0) {
      this.services.splice(index, 1);
    }
  }
  add(event: any) {
    const value = (event.value || '').trim();
    if (value && this.services.indexOf(value) < 0) { this.services.push(value) }
    else this.toastr.error("This service has been already added");
    event.chipInput!.clear();
    this.addClientForm.controls['serviceName'].setValue(null);

  }

  close(value: Boolean) {
    if (this.addClientForm.valid) {
      this.dialogRef.close(value);
    }
  }

  options: any = {
    types: [],
    componentRestrictions: { country: 'US' },
  }
  @ViewChild("placesRef")
  placesRef!: GooglePlaceDirective;

  selectedAddressText: string[] = [];

  handleAddressChange(address: any, type: any, index?: number) {
    console.log(address);

    const addressControl = <FormArray>this.addClientForm.controls["serviceAddress"];
    const formGroup = addressControl.controls[index];

    // Clear previous values
    formGroup.patchValue({
      addressLine1: '',
      addressLine2: '',
      city: '',
      state: '',
      country: '',
      zipCode: '',
      lat: '',
      long: ''
    });

    const addressLine1: string[] = [];
    const addressLine2: string[] = [];
    let zipCode = '';

    address?.addressComponents?.forEach((item: any) => {
      const type = item?.types?.[0];

      switch (type) {
        case 'street_number':
        case 'route':
          addressLine1.push(item?.longText);
          break;

        case 'neighborhood':
        case 'sublocality_level_1':
          addressLine2.push(item?.longText);
          break;

        case 'locality':
          formGroup.patchValue({ city: item?.longText });
          break;

        case 'administrative_area_level_1':
          formGroup.patchValue({ state: item?.longText });
          break;

        case 'country':
          formGroup.patchValue({ country: item?.longText });
          break;

        case 'postal_code':
          zipCode = item?.longText;
          break;

        case 'postal_code_suffix':
          if (!zipCode) zipCode = item?.longText;
          break;
      }
    });

    // Set joined values
    formGroup.patchValue({
      addressLine1: addressLine1.join(' '),
      addressLine2: addressLine2.join(' '),
      zipCode: zipCode,
      lat: address?.geometry?.location?.lat || '',
      long: address?.geometry?.location?.lng || ''
    });
    // Set display string for input (if used)
    this.selectedAddressText[index] = address?.formattedAddress || '';
  }


  getPhone(form: any) {
    return form.controls.phone.controls;
  }
  getContact(form: any) {
    return form.controls.contact.controls;
  }
  removePhone(index: any) {
    const control = this.addClientForm.get('phone') as FormArray
    control.length > 1 ? control.removeAt(index) : '';
  }
  addMoreNumber(num?: any, cat?: any) {
    const control = this.addClientForm.get('phone') as FormArray;
    control.push(this.phoneForm(num, cat));
  }
  addServiceAddress(edit?: boolean) {
    const control = this.addClientForm.get('serviceAddress') as FormArray;
    const isFirstAddress = control.length === 0;
    control.push(this.addressForm(edit, isFirstAddress));
  }
  addressForm(edit?: boolean, isPrimary = false) {
    console.log(edit)

    return (edit) ? this.fb.group({
      _id: [''],
      addressLine1: ['', Validators.required],
      addressLine2: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      country: ['', Validators.required],
      zipCode: ['', [Validators.required, Validators.pattern(AppConst.ZIPCODE_PATTERN)]],
      lat: [''],
      long: [''],
      isPrimary: [isPrimary],

    }) : this.fb.group({
      addressLine1: ['', Validators.required],
      addressLine2: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      country: ['', Validators.required],
      zipCode: ['', [Validators.required, Validators.pattern(AppConst.ZIPCODE_PATTERN)]],
      lat: [''],
      long: [''],
      isPrimary: [isPrimary]
    })

  }
  getAddress(form) {
    return form.controls.serviceAddress.controls;
  }
  phoneForm(num?: any, cat?: any) {
    return this.fb.group({
      number: [num ? num : ''],
      category: [cat ? cat : '']
    })
  }
  get addressControls() {
    return <FormArray>this.addClientForm.controls["serviceAddress"]
  }


  addMoreContact(contactTitle?: any, contactName?: any, contactEmail?: any, contactPhoneNumber?: any, contactPhoneCategory?: any, contactId?: any) {
    const control = this.addClientForm.get('contact') as FormArray;
    control.push(this.contactForm(contactTitle, contactName, contactEmail, contactPhoneNumber, contactPhoneCategory, contactId));
  }

  contactForm(contactTitle, name, email, num, cat, id) {
    return this.fb.group({
      contactId: [id ? id : ''],
      contactTitle: [contactTitle ? contactTitle : '', Validators.required],
      contactName: [name ? name : '', Validators.required],
      contactEmail: [email ? email : '', [Validators.required, Validators.pattern(AppConst.EMAIL_PATTERN)]],
      contactNumber: [num ? num : '', Validators.required],
      contactCategory: [cat ? cat : '', Validators.required]
    })
  }

  removeContact(index: any) {
    const control = this.addClientForm.get('contact') as FormArray
    control.length > 1 ? control.removeAt(index) : '';
  }


  toggleAllSelection() {
    if (this.allSelected) {
      this.select.options.forEach((item: MatOption) => item.select());
    } else {
      this.select.options.forEach((item: MatOption) => item.deselect());
    }
  }
  optionClick() {
    let newStatus = true;
    this.select.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.allSelected = newStatus;
  }
  onCheckboxChange(index: number) {
    const formArray = this.addClientForm.get('serviceAddress') as FormArray;
    const checkboxes = formArray.controls.map(control => control.get('isPrimary'));

    checkboxes.forEach((checkbox, idx) => {
      if (idx !== index) {
        checkbox.setValue(false); // Uncheck other checkboxes
      }
    });
  }
  deletedArray: any = [];
  removeAddress(index: any) {
    this.data?.data?.address.forEach((element, elementIndex) => {
      if (elementIndex == index) {
        this.deletedArray.push(element?._id)
      }
    })
    console.log(this.deletedArray)
    const control = this.addClientForm.get('serviceAddress') as FormArray
    control.length > 1 ? control.removeAt(index) : '';
  }
  patchAddresses(data) {
    console.log(data)
    const empData = data.data.address;
    console.log(empData)
    if (empData) {
      const addresses = Array.isArray(empData) ? empData : [empData];
      addresses.forEach((address) => {
        console.log(address)
        this.addServiceAddress(true);
        const control = this.addClientForm.get('serviceAddress') as FormArray;
        const lastIndex = control.length - 1;
        control.at(lastIndex).patchValue(address);
      });
    }
  }

  resetForm() {
    this.addClientForm.reset();
    this.imageUrl = 'assets/images/person.svg';
    this.storage.clearItem('clientForm');
  }
}
